import { GalleryTitleStyle } from '@website-builder/widgets/gallery/model/gallery-title-style';

export class GallerySubtitleStyle extends GalleryTitleStyle {
  alignment = '';

  static normalize(styles: Partial<GallerySubtitleStyle>): GallerySubtitleStyle {
    const galleryTitleStyle: GalleryTitleStyle = GalleryTitleStyle.normalize(styles);
    const pureStyles = new GallerySubtitleStyle();

    Object.assign(pureStyles, galleryTitleStyle);

    pureStyles.alignment = styles.alignment ?? pureStyles.alignment;

    return pureStyles;
  }
}
